import React from "react";
import styled, { keyframes } from "styled-components"

const MoveIn = keyframes`
  from {
    -webkit-transform: translate3d(-100vw, 0, 0);
    transform: translate3d(-100vw, 0, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

`


const HeroTextContainer = styled.div`
  position: ${props => props.pos ? props.pos : "relative"};
  top: 20vh;
  bottom: ${props => props.b ? props.b : "unset"};
  left: ${props => props.l ? props.l : "unset"};
  right: ${props => props.r ? props.r : "unset"};
  width: 100%;
  padding: 3vh 5vh 5vh 5vh;
  background-color: rgba(2,56,175, .7);
  border-radius: 50px;
  animation-name: ${MoveIn};
  
  
  //animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-duration: 1s;

  @media only screen and (min-width: 600px) {
    top: 30vh;
  }
  
  * {
    color: #fff;
  }
  
  .container {
  background-color: rgba(2,56,175, .7);
  padding: 1.5rem 1.5rem;
  border-radius: 20px;
  }
  
  h2 {
  margin: 0 0 1.5rem 0;
  font-weight: 700;
  word-break: break-all;
  }
  h4 {
    font-family: 'Open Sans', sans-serif;
  }

`



const HeroText = (props) => {


  return (
     <HeroTextContainer {...props}>
       {props.children}
     </HeroTextContainer>
  )
}

export default HeroText;

//music
//plex